import React, {memo} from "react"
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import FormSection from "../../../components/FormSection";
import Model1MeasureField from "./Model1MeasureField";
import Model1Select from "./Model1Select";
import {formikPropertyEqual} from "./index";


export const snowMeteorologicalDataColumns = ['ww', 'v', 'n', 'vq1', 'vq2', 'ta', 'tMin', 'tMax'];

const SnowMeteorologicalData = memo(({formik, model1Registry, warnings, inputDisabled, visibleColumns}) => {
    const {t} = useTranslation(['models1']);

    const wwRegistry = model1Registry.data?.ww ?? [];
    const vRegistry = model1Registry.data?.v ?? [];
    const nRegistry = model1Registry.data?.n ?? [];
    const vq1Registry = model1Registry.data?.vq1 ?? [];
    const vq2Registry = model1Registry.data?.vq2 ?? [];

    const isVisible = (column) => (!visibleColumns || visibleColumns?.[column]);

    return <FormSection title={t('model1Form.snowMeteorologicalData')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            {
                isVisible("ww") && <>
                <Grid item xs={12} md={6}>
                    <Model1Select name="ww" formik={formik} registry={wwRegistry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
                    <Grid item xs={6} sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
            {
                isVisible("n") &&
                <Grid item xs={12} md={6}>
                    <Model1Select name="n" formik={formik} registry={nRegistry} labelFn={r => `${r.code} - ${r.observation}`} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("v") &&
                <Grid item xs={12} md={6}>
                    <Model1Select name="v" formik={formik} registry={vRegistry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("vq1") &&
                <Grid item xs={12} md={6}>
                    <Model1Select name="vq1" formik={formik} registry={vq1Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("vq2") &&
                <Grid item xs={12} md={6}>
                    <Model1Select name="vq2" formik={formik} registry={vq2Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("ta") &&
                <>
                    <Grid item xs={12} md={6}>
                        <Model1MeasureField name="ta" formik={formik} unitOfMeasure="°C" warnings={warnings}
                                            disabled={inputDisabled} type="number"/>
                    </Grid>
                    <Grid item xs={6} sx={{display: {xs: "none", md: "block"}}}/>
                </>

            }
            {
                isVisible("tMin") &&
                <Grid item xs={12} md={6}>
                    <Model1MeasureField name="tMin" formik={formik} unitOfMeasure="°C" warnings={warnings}
                                        disabled={inputDisabled} type="number"/>
                </Grid>
            }
            {
                isVisible("tMax") &&
                <Grid item xs={12} md={6}>
                    <Model1MeasureField name="tMax" formik={formik} unitOfMeasure="°C" warnings={warnings}
                                        disabled={inputDisabled} type="number"/>
                </Grid>
            }
        </Grid>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyEqual(prevProps, nextProps, snowMeteorologicalDataColumns));

export default SnowMeteorologicalData;